import Moment from "moment";
import Constants from 'config/constants';

const handleAnalyticCall = function handleAnalyticCall(pickupWebsite, orderNumber, storeNumber, pickedUpBy, action, errorId, errorMessage) {
	var dateString = Moment.utc(new Date()).format("MM-DD-YYYY");
	var dateTimeString = Moment.utc(new Date()).format("HH:mm");

	let tempSiteData = {
		Chain: `${pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "Golf Galaxy" : (pickupWebsite === Constants.COOKIE_PUBLIC_LANDS) ? "Public Lands" : "DICK'S Sporting Goods"}`,
		DYMTerm: "",
		DYMType: "",
		EnteredSearchTerm: "",
		ErrorID: errorId,
		ErrorMessage: errorMessage,
		LoyaltyID: "",
		LoyaltyPointsBalance: "",
		OrderID: orderNumber,
		StoreNumber: storeNumber,
		PickedUpBy: pickedUpBy,
		PageName: "Order Pickup",
		PageType: "static",
		ReferringPageURL: document.referrer,
		OrderPickupAction: action,
		ReplacementTerm: "",
		ReplacementType: "",
		SearchType: "",
		SearchResultCount: "",
		ServerDate: dateString,
		ServerTime: dateTimeString,
		SessionID: getDSGCookie("sessionId"),
		UserID: "",
		VisitNumber: getDSGCookie("visits")
	};

	var userCookie = getCookie("WCS_API_USER_ID");
	if (userCookie !== "") {
		tempSiteData.UserID = userCookie;
	} else {
		tempSiteData.UserID = "-1002";
	}

	if (typeof window.siteData !== "undefined") {
		let newSiteData = Object.assign(window.siteData, tempSiteData);
		window.siteData = newSiteData;
	} else {
		window.siteData = tempSiteData;
	}

	TriggerAnalyticsEvent("reporting:PagePostRender", window.siteData);
};

export default handleAnalyticCall;

export function getCookie(cname) {
	var name = cname + "=";
	var ca = typeof document !== "undefined" ? document.cookie.split(";") : [];
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}

	return "";
}

export function getDSGCookie(name) {
	try {
		var cname = getCookie("authTokens");
		var cvalue = decodeURIComponent(cname);
		var cookie = "";
		if (cvalue.length > 0) {
			var json = JSON.parse(cvalue);
			cookie = name in json ? json[name] : "";
		}
	} catch (e) {
		//do nothing
	}
	return cookie;
}

export function TriggerAnalyticsEvent(eventName, eventData) {
	try {
		let myEvent = new CustomEvent(eventName, {
			detail: eventData
		});
		document.dispatchEvent(myEvent);
	} catch (ex) {
		let _dsgTag;
		_dsgTag.HelperFunctions.DebugLog(
			"Failed to trigger event '" + eventName + "':" + ex.message,
			true
		);
	}
}
